(function() { module.exports = window["wp"]["dom"]; }());